import React from 'react';
import { Download, X, Monitor } from 'lucide-react';
import LatteButton from '../common/LatteButton';

const BrowserPDFGuideModal = ({ isOpen, onConfirm, onCancel }) => {
  // 브라우저별 렌더링 함수
  const renderMessage = () => {
    const userAgent = navigator.userAgent;
    
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
      return (
        <p className="text-gray-700 text-center leading-relaxed">
          인쇄 대화상자에서 대상이{' '}
          <span className="bg-latte-light px-1 rounded font-semibold text-latte-dark">
            "PDF로 저장"
          </span>
          으로 선택되어 있는지 확인하고 저장 버튼을 클릭하세요
        </p>
      );
    }
    
    if (userAgent.includes('Firefox')) {
      return (
        <p className="text-gray-700 text-center leading-relaxed">
          인쇄 대화상자에서 대상이{' '}
          <span className="bg-latte-light px-1 rounded font-semibold text-latte-dark">
            "PDF로 저장"
          </span>
          으로 선택되어 있는지 확인하고 인쇄 버튼을 클릭하세요
        </p>
      );
    }
    
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      return (
        <p className="text-gray-700 text-center leading-relaxed">
          인쇄 대화상자 하단의{' '}
          <span className="bg-latte-light px-1 rounded font-semibold text-latte-dark">
            PDF 버튼
          </span>
          을 클릭한 후 "PDF로 저장"을 선택하세요
        </p>
      );
    }
    
    if (userAgent.includes('Edg')) {
      return (
        <p className="text-gray-700 text-center leading-relaxed">
          인쇄 대화상자에서 대상이{' '}
          <span className="bg-latte-light px-1 rounded font-semibold text-latte-dark">
            "PDF로 저장"
          </span>
          으로 선택되어 있는지 확인하고 저장 버튼을 클릭하세요
        </p>
      );
    }
    
    // 기본값 (Chrome 방식)
    return (
      <p className="text-gray-700 text-center leading-relaxed">
        인쇄 대화상자에서 대상이{' '}
        <span className="bg-latte-light px-1 rounded font-semibold text-latte-dark">
          "PDF로 저장"
        </span>
        으로 선택되어 있는지 확인하고 저장 버튼을 클릭하세요
      </p>
    );
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) {
        onCancel();
      }
    }}>
      <div className="modal modal-lg">
        {/* 헤더 영역 */}
        <div className="modal-header-gradient">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Download className="w-6 h-6 text-white" />
              <div>
                <h2 className="text-xl font-bold text-white">이력서 PDF 다운로드</h2>
              </div>
            </div>
            <button
              onClick={onCancel}
              className="modal-close-btn-light"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* 컨텐츠 */}
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="modal-icon-wrapper info mb-3">
              <Monitor className="w-7 h-7 text-white" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              이력서를 PDF 파일로 저장하세요
            </h3>
            <p className="text-sm text-gray-600">
              인쇄 대화상자가 열리면 PDF로 저장 옵션을 선택하여 다운로드할 수 있습니다
            </p>
          </div>

          {/* 메시지 */}
          <div className="mb-5">
            <div className="bg-latte-lightest border border-latte-light rounded-lg p-3">
              {renderMessage()}
            </div>
          </div>

          {/* 버튼들 */}
          <div className="flex gap-3">
            <LatteButton
              onClick={onCancel}
              variant="secondary"
              size="md"
              className="flex-1"
            >
              취소
            </LatteButton>
            <LatteButton
              onClick={onConfirm}
              variant="gradient"
              size="md"
              className="flex-1"
            >
              <Download className="w-4 h-4" />
              PDF 다운로드 시작
            </LatteButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowserPDFGuideModal;